import PropTypes from 'prop-types'
import React from 'react'
import { Header } from '../../Header'
import { Address } from '../Address'
import { FieldArray } from 'redux-form'
import { connect } from 'react-redux'
import { getUserInfo } from '../../../../../selectors'
import { WorkingTime } from '../WorkingTime'
import { AddAddressBtn } from '../AddAddressBtn'
import { RemoveAddressBtn } from '../RemoveAddressBtn'
import config from 'SRC/config/config.yaml'

export class Container extends React.Component {
  isBusinessUser = () => this.props.type && this.props.type !== config.userTypes.freeUserTypeSeo

  getHeader = () => this.isBusinessUser() ? 'Adresa (Glavna)' : 'Adresa stanovanja'

  getMainAddressIndex = () => {
    if (this.props.userAddresses.length) {
      const mainIndex = this.props.userAddresses.findIndex(item => Boolean(item.main))
      if (mainIndex > -1) {
        return mainIndex
      }
      return 0
    }
    return -1
  }

  renderAddresses = ({fields, mainIndex}) => {
    return [
      fields.map((item, index) =>
        index < this.props.maxAddressesCount && index !== mainIndex
          ? [
            <Header key={`header-${item}`}>Adresa (Dodatna)</Header>,
            <Address key={`address-${item}`} index={index} isBusiness />,
            <WorkingTime key={`workingTime-${item}`} index={index} />,
            <RemoveAddressBtn onClick={() => fields.remove(index)} key={`removeBtn-${index}`} />
          ]
          : null
      ),
      fields.length < this.props.maxAddressesCount
        ? <AddAddressBtn onClick={() => fields.push()} key='addAddressBtn' />
        : null
    ]
  }

  render () {
    const mainIndex = this.getMainAddressIndex()
    const isBusinessUser = this.isBusinessUser()
    return [
      <Header key={`header-${mainIndex}`}>{this.getHeader()}</Header>,
      <Address key={`address-${mainIndex}`} index={mainIndex} isBusiness={isBusinessUser} />,
      isBusinessUser ? <WorkingTime key={`workingTime-${mainIndex}`} index={mainIndex} /> : null,
      isBusinessUser
        ? <FieldArray key='addresses' component={this.renderAddresses} name='userAddresses' mainIndex={mainIndex} />
        : null
    ]
  }
}

Container.displayName = 'Addresses'

const mapStateToProps = state => {
  const result = {type: '', maxAddressesCount: 3}
  const userInfo = getUserInfo(state)
  if (userInfo) {
    if (userInfo.type && userInfo.type.seo) {
      result.type = userInfo.type.seo
    }
    if (userInfo.userAddresses && Array.isArray(userInfo.userAddresses)) {
      result.userAddresses = [...userInfo.userAddresses]
    }
    if (userInfo.packages && Array.isArray(userInfo.packages) && userInfo.packages.length) {
      const maxAddressesCount = userInfo.packages[0].locationLimit
      if (maxAddressesCount) {
        result.maxAddressesCount = maxAddressesCount
      }
    }
  }
  return result
}

Container.propTypes = {
  type: PropTypes.string.isRequired,
  userAddresses: PropTypes.arrayOf(PropTypes.shape({
    main: PropTypes.bool,
    id: PropTypes.number.isRequired
  })),
  maxAddressesCount: PropTypes.number.isRequired
}

Container.defaultProps = {
  type: '',
  userAddresses: [],
  maxAddressesCount: 1
}

export default connect(mapStateToProps)(Container)
